import { ToolRole, User, UserTool } from '../../dorian-shared/types/user/User';
import { auth } from '../Auth/Auth';

// Ordered weakest to strongest; index is the rank. Mirrors TOOL_ROLES on the server.
export const TOOL_ROLES: ToolRole[] = ['viewer', 'editor'];

export const TOOL_PERMISSIONS_KEY = 'tool-permissions';

const ADMIN_ONLY_TOOL_KEYS = new Set([TOOL_PERMISSIONS_KEY]);

function roleRank(role: ToolRole | string) {
  const idx = TOOL_ROLES.indexOf(role as ToolRole);
  return idx === -1 ? -1 : idx;
}

function getUserTools(user?: User | null): UserTool[] {
  const checkUser = user || auth.getUser();
  return checkUser?.tools || [];
}

export function getToolRole(user: User | undefined | null, toolKey: string): ToolRole | null {
  const tool = getUserTools(user).find((entry) => entry.key === toolKey);
  return tool?.role || null;
}

export function hasToolAccess(
  user: User | undefined | null,
  toolKey: string,
  minRole: ToolRole = 'viewer',
) {
  const role = getToolRole(user, toolKey);
  if (!role) {
    return false;
  }
  return roleRank(role) >= roleRank(minRole);
}

export function isAdminOnlyTool(toolKey: string) {
  return ADMIN_ONLY_TOOL_KEYS.has(toolKey);
}

/**
 * Tools an admin can hand out. Admin-only entries are in every admin's tool
 * list so the menu can show them, but they are never grantable.
 */
export function getGrantableTools(user?: User | null): UserTool[] {
  return getUserTools(user).filter((tool) => !isAdminOnlyTool(tool.key));
}
